import { render, staticRenderFns } from "./LostSimpleInfo.vue?vue&type=template&id=448ad4d4&scoped=true&"
import script from "./LostSimpleInfo.vue?vue&type=script&lang=js&"
export * from "./LostSimpleInfo.vue?vue&type=script&lang=js&"
import style0 from "./LostSimpleInfo.vue?vue&type=style&index=0&id=448ad4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ad4d4",
  null
  
)

export default component.exports